import React from 'react'

// Styles //
import "./bookCard.scss";

interface BookCardProps {
    img: string;
    author: string;
    title: string;
    link?: string;
    children?: JSX.Element;
    fallback?: string;
    onClickShare: (e) => void;
    setLinkUrl: (url:string) => void;
}

const BookCard = (props: BookCardProps) => {
    const { fallback, author, title, img, link, children, onClickShare, setLinkUrl} = props;

    const handleImageError = fallback => event => event.target.src = fallback;

    return (
        <div className="m-book-card">
            {link ? (
                <a data-title-book={title} href={link} target="_blank" className={`m-book-card__image gtmClickBook${title.replace(/\s+/g, "")}`} rel="noreferrer">
                    {children}
                    <img src={img} alt={title} onError={handleImageError(fallback)}/>
                </a>
            ):(
                <div className="m-book-card__image">
                    {children}
                    <img src={img} alt={title} onError={handleImageError(fallback)}/>
                </div>
            )}
            <div className="m-book-card__description">
                <div className="m-book-card__description__details">
                    <p>{title}</p>
                    <span>{author}</span>
                </div>
                <div className="m-book-card__description__share">
                    <span data-title-book={title} className={`gtmClickShareBook${title.replace(/\s+/g, "")}`} 
                        onClick={() => {
                        onClickShare(true);
                        setLinkUrl(link ? link : "");
                    }}><i className="icon-share-alt"></i>Compartir</span>
                </div>
            </div>
        </div>
    )
}

export default BookCard;